import CheckIconAlt from '@src/svgs/CheckIconAlt';
import React from 'react';
import styled from 'styled-components';

export type PhotoSourceSelection = {
  brandKit: boolean;
  story: boolean;
};

interface PhotoSourceFilterComponentProps {
  selectedSources: PhotoSourceSelection;
  setSelectedSources: (sources: PhotoSourceSelection) => void;
  align?: 'center' | 'left';
}

const PhotoSourceFilterComponent: React.FC<PhotoSourceFilterComponentProps> = ({
  align = 'left',
  selectedSources,
  setSelectedSources,
}) => {
  const handleToggle = (source: keyof PhotoSourceSelection) => {
    setSelectedSources({
      ...selectedSources,
      [source]: !selectedSources[source],
    });
  };

  return (
    <PhotoSourceFilterSection>
      <SectionLabel>Photo Sources</SectionLabel>
      <CheckboxRow align={align}>
        <CheckBoxContainer onClick={() => handleToggle('brandKit')}>
          <CheckBox isChecked={selectedSources.brandKit} role="button">
            {selectedSources.brandKit && <CheckIconAlt />}
          </CheckBox>
          <div className="checkbox-text">Brand Kit</div>
        </CheckBoxContainer>
        <CheckBoxContainer onClick={() => handleToggle('story')}>
          <CheckBox isChecked={selectedSources.story} role="button">
            {selectedSources.story && <CheckIconAlt />}
          </CheckBox>
          <div className="checkbox-text">Story</div>
        </CheckBoxContainer>
      </CheckboxRow>
      {!selectedSources.brandKit && !selectedSources.story && (
        <WarningText>At least one photo source must be selected</WarningText>
      )}
    </PhotoSourceFilterSection>
  );
};

export default PhotoSourceFilterComponent;

const PhotoSourceFilterSection = styled.div`
  width: 100%;
`;

const SectionLabel = styled.div`
  color: var(--text-secondary);
  font-size: var(--text-xs);
  line-height: 140%;
  margin-bottom: 12px;
`;

const CheckboxRow = styled.div<{ align: 'center' | 'left' }>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 24px;
`;

const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .checkbox-text {
    color: var(--text-secondary);
    font-size: var(--text-xs);
    line-height: 140%;
  }
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  border: 0;
  outline: 0;
  background-color: ${props =>
    props.isChecked ? 'var(--accent)' : 'transparent'};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: ${props => !props.isChecked && '1px solid var(--text-muted)'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WarningText = styled.div`
  color: var(--destructive);
  font-size: var(--text-xs);
  margin-top: 8px;
`;
